<main role="main" data-testid="sot-splashscreen">
  <article class="splash">
    <a (click)="navigateToOrdertype()" [ngSwitch]="showTemplate">

      <ng-template [ngSwitchCase]="'slider'">
        <swiper class="swiper-container" [config]="swiper_config" #SplashSwiper>
          <div *ngFor="let startpageViewModel of startpageViewModels" class="swiper-slide">
            <img class="ya_image" [src]="startpageViewModel.media_path" />
          </div>
        </swiper>
      </ng-template>

      <ng-template [ngSwitchCase]="'video'">
        <video class="ya_video" [src]="startpageViewModels[0].media_path" loop muted autoplay></video>
      </ng-template>
      <ng-template ngSwitchDefault>
        <img class="ya_image" [src]="startpageViewModels[0].media_path" />
      </ng-template>
    </a>    
  </article>
</main>